import { render, staticRenderFns } from "./ReportCODShipments.vue?vue&type=template&id=2df119d7&"
import script from "./ReportCODShipments.vue?vue&type=script&lang=js&"
export * from "./ReportCODShipments.vue?vue&type=script&lang=js&"
import style0 from "./ReportCODShipments.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports